import { fromJS } from 'immutable';
import PrizeActions from '../actions/PrizeActions';
import { PAYMENT_HANDLER } from '../constants/PayoutConstants';

const {
    GET_PRIZES,
    GET_PRIZES_SUCCESS,
    GET_PRIZES_FAILED
} = PrizeActions.TYPES;

export const DEFAULT_STATE = fromJS({
    hasError: false,
    identityId: null,
    identityTaxVerified: true,
    isLoading: false,
    offlinePayment: false,
    winnings: []
});

export default function(state = DEFAULT_STATE, action) {
    let newState = state;
    switch (action.type) {
        case GET_PRIZES: {
            newState = newState.updateIn(['isLoading'], () => true);
            return newState;
        }
        case GET_PRIZES_SUCCESS: {
            const { resp } = action.payload;
            newState = newState.updateIn(['isLoading'], () => false);
            newState = newState.updateIn(['identityId'], () => fromJS(resp.identityId));
            newState = newState.updateIn(['identityTaxVerified'], () => fromJS(resp.identityTaxVerified));
            newState = newState.updateIn(['winnings'], () => fromJS(resp.winnings));
            newState = newState.updateIn(['offlinePayment'], () => fromJS(resp.paymentHandler === PAYMENT_HANDLER.EPIC));
            return newState;
        }
        case GET_PRIZES_FAILED: {
            newState = newState.updateIn(['isLoading'], () => false);
            newState = newState.updateIn(['hasError'], () => true);
            return newState;
        }
        default:
            return newState;
    }
}
